// @flow

import React from "react";
import { compose } from "redux";
import { connect } from "react-redux";
import { localize } from "redux-i18n";
import actionCreators from "@modules/employee/actionCreator";
import * as employeeSelectors from "@modules/employee/selectors";
import { Button, SchemaForm } from "@components";
import { uiSchema } from "./uiSchema";
import type { StepProps } from "@components";
import type { State } from "@store/reducers";
import { split } from "@transformers/schema";

type OwnProps = $Exact<{
  clientId: number,
}>;

type PropsFromState = $Exact<{
  schema: Object | null,
  alertId: number,
}>;

type PropsFromDispatch = $Exact<{
  getClientAlert: typeof actionCreators.GetClientAlert,
}>;

type Props = $Exact<{
  ...OwnProps,
  ...StepProps,
  ...PropsFromLocalize,
  ...PropsFromState,
  ...PropsFromDispatch,
}>;

export class Step1ChooseAlert extends React.Component<Props> {
  chooseAlertSchema = split(this.props.schema, ["alertConfiguration"]);

  constructor(props: Props) {
    super(props);
    // Class components needs constructor for accessing the SchemaForm's ref
    this.formRef = React.createRef();
  }

  handleChooseAlertNext = () => {
    if (this.formRef) {
      this.formRef.current.submit();
    }
  };

  handleSubmit = (formData: Object) => {
    this.props.getClientAlert({
      clientId: this.props.clientId,
      alertId: formData.alertConfiguration.id,
    });
    if (this.props.handleSubmit) {
      this.props.handleSubmit(formData, true);
    }
  };

  get data(): Object {
    return {
      alertConfiguration: {
        id: this.props.alertId,
      },
    };
  }

  render() {
    if (!this.props.editable) {
      return null;
    }

    return (
      <React.Fragment>
        <div className="w-100 d-flex justify-content-center">
          <div className="col-sm-8">
            <SchemaForm
              ref={this.formRef}
              className="w-100"
              formData={this.data}
              schema={this.chooseAlertSchema}
              uiSchema={uiSchema(this.props.t)}
              onSubmit={this.handleSubmit}
              externalSubmit
            >
              <div className="d-flex justify-content-center" />
            </SchemaForm>
          </div>
        </div>
        <div className="w-100 d-flex justify-content-end mt-5 mb-3">
          <Button onClick={this.handleChooseAlertNext}>
            {this.props.t("ADD_EXLUSION_ALERT_STEP_1_NEXT_BUTTON")}
          </Button>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state: State, ownProps: Object): PropsFromState => {
  return {
    schema: employeeSelectors.getEmployeeAlertExclusionSchema(state),
    alertId: employeeSelectors.getClientAlertId(state),
  };
};

const mapDispatchToProps: PropsFromDispatch = {
  getClientAlert: actionCreators.GetClientAlert,
};

export default compose(localize(), connect(mapStateToProps, mapDispatchToProps))(Step1ChooseAlert);
